import React, { useState } from 'react';
import { useInView } from '../useInView';

const IMGS = [
  { url: '/images/laminated-shop-1.png', label: 'Shopping Bags', size: 'big' },
  { url: '/images/nonwoven-dcut-1.png', label: 'Non-Woven D-Cut Bags', size: 'sm' },
  { url: '/images/laminated-shop-2.png', label: 'Shopping Bags', size: 'sm' },
  { url: '/images/plastic-carry-1.png', label: 'Printed Plastic Carry Bags', size: 'sm' },
  { url: '/images/nonwoven-dcut-2.png', label: 'Non-Woven D-Cut Bags', size: 'sm' },
  { url: '/images/nonwoven-wcut-1.png', label: 'Non-Woven W-Cut Bags', size: 'sm' },
  { url: '/images/glossy-gold-bag-1.jpg', label: 'Glossy Gold Printed Shining Bags', size: 'sm' },
  { url: '/images/metallic-lamination-bag-1.jpg', label: 'Customized Metallic Bags', size: 'sm' },
];

export default function Gallery() {
  const [light, setLight] = useState(null);
  const [ref, v] = useInView();

  return (
    <>
      <style>{`
        .gal-item { transition: transform 0.35s ease !important; }
        .gal-item:hover { transform: scale(1.02) !important; }
        .gal-item:hover .gal-overlay { opacity:1 !important; }
        .gal-item:hover img { transform: scale(1.07) !important; }
        @keyframes lightboxIn { from{opacity:0;transform:scale(0.9)} to{opacity:1;transform:scale(1)} }
        @media(max-width:768px){
          .gal-grid { grid-template-columns:1fr 1fr !important; grid-template-rows:auto !important; }
          .gal-big { grid-row:auto !important; grid-column:1/3 !important; }
        }
        @media(max-width:480px){
          .gal-grid { grid-template-columns:1fr !important; }
          .gal-big { grid-column:1 !important; }
          .gal-title { font-size:clamp(28px,8vw,40px)!important; }
          .gal-sub { font-size:15px !important; line-height:1.6 !important; }
        }
      `}</style>

      <section id="gallery" style={s.section}>
        <div style={s.container}>
          <div ref={ref} style={{ ...s.header, opacity: v ? 1 : 0, transform: v ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease' }}>
            <div style={s.tagLine}><span style={s.dash} /><span style={s.tag}>OUR GALLERY</span><span style={s.dash} /></div>
            <h2 className="gal-title" style={s.title}>Our Work Speaks<br /><em style={s.titleItalic}>For Itself</em></h2>
            <p className="gal-sub" style={s.sub}>Real products manufactured for shops & brands across Hyderabad.</p>
          </div>

          <div className="gal-grid" style={s.grid}>
            {IMGS.map((img, i) => (
              <div
                key={i}
                className={`gal-item${img.size === 'big' ? ' gal-big' : ''}`}
                style={{
                  ...s.item,
                  ...(img.size === 'big' ? s.bigItem : {}),
                  opacity: v ? 1 : 0,
                  transform: v ? 'none' : 'translateY(24px)',
                  transition: `opacity 0.6s ease ${i * 0.08}s, transform 0.6s ease ${i * 0.08}s`,
                  cursor: 'pointer',
                }}
                onClick={() => setLight(img)}
              >
                <img src={img.url} alt={img.label} style={{ ...s.img, ...(img.size === 'big' ? s.bigImg : {}) }} loading="lazy" />
                <div className="gal-overlay" style={s.overlay}>
                  <span style={s.overlayLabel}>{img.label}</span>
                  <span style={s.overlayIcon}>🔍</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {light && (
          <div style={s.lightbox} onClick={() => setLight(null)}>
            <div style={s.lbInner} onClick={e => e.stopPropagation()}>
              <img src={light.url.replace('w=700', 'w=1200')} alt={light.label} style={s.lbImg} />
              <div style={s.lbLabel}>{light.label}</div>
              <button style={s.lbClose} onClick={() => setLight(null)}>✕</button>
            </div>
          </div>
        )}
      </section>
    </>
  );
}

const s = {
  section: { background: '#0d0d0d', padding: '120px 24px' },
  container: { maxWidth: 1280, margin: '0 auto' },
  header: { textAlign: 'center', marginBottom: 56 },
  tagLine: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 16 },
  dash: { width: 40, height: 1, background: 'rgba(200,137,58,0.5)', display: 'inline-block' },
  tag: { fontSize: 11, letterSpacing: 4, color: '#c8893a', fontWeight: 700 },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(32px,4vw,54px)', fontWeight: 700,
    color: '#f0ede6', lineHeight: 1.15, marginBottom: 12,
  },
  titleItalic: { fontStyle: 'italic', color: '#c8893a' },
  sub: { fontSize: 15, color: 'rgba(240,237,230,0.5)' },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gridTemplateRows: '320px 240px',
    gap: 12,
  },
  item: {
    borderRadius: 16, overflow: 'hidden', position: 'relative',
    boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
  },
  bigItem: { gridRow: '1/3', gridColumn: '1/2' },
  img: { width: '100%', height: 240, objectFit: 'cover', display: 'block', transition: 'transform 0.5s ease' },
  bigImg: { height: '100%' },
  overlay: {
    position: 'absolute', inset: 0,
    background: 'linear-gradient(to top, rgba(10,10,10,0.85) 0%, rgba(10,10,10,0.3) 50%, transparent 100%)',
    display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
    padding: '16px 18px', opacity: 0, transition: 'opacity 0.3s ease',
  },
  overlayLabel: { color: '#f0ede6', fontSize: 14, fontWeight: 700, letterSpacing: 0.3 },
  overlayIcon: { position: 'absolute', top: 14, right: 14, fontSize: 18, opacity: 0.8 },
  lightbox: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)', zIndex: 99999,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    backdropFilter: 'blur(8px)',
  },
  lbInner: {
    position: 'relative', borderRadius: 20, overflow: 'hidden',
    maxWidth: 900, width: '100%', animation: 'lightboxIn 0.3s ease',
    boxShadow: '0 40px 100px rgba(0,0,0,0.8)',
  },
  lbImg: { width: '100%', maxHeight: '80vh', objectFit: 'cover', display: 'block' },
  lbLabel: {
    position: 'absolute', bottom: 0, left: 0, right: 0,
    background: 'linear-gradient(transparent, rgba(10,10,10,0.9))',
    color: '#f0ede6', padding: '24px 20px 16px', fontSize: 16, fontWeight: 700,
  },
  lbClose: {
    position: 'absolute', top: 14, right: 14,
    background: 'rgba(10,10,10,0.8)', border: '1px solid rgba(255,255,255,0.2)',
    color: '#f0ede6', width: 36, height: 36, borderRadius: '50%',
    fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
};
